import {Pipe, PipeTransform} from '@angular/core';
import * as moment from 'moment';

const momentConstructor = moment;

@Pipe({name: 'amDateFormat'})
export class DateFormatPipe implements PipeTransform {
  public transform(value: Date | moment.Moment | string | number, ...args: any[]): string {
    if (!value) {
      return '';
    }

    let format = args[0];

    if (format === undefined) {
      format = 'LLL';
    }

    return momentConstructor(value).format(format);
  }
}
